import { render, staticRenderFns } from "./elite_position_details.vue?vue&type=template&id=96d5e4b2&scoped=true&"
import script from "./elite_position_details.vue?vue&type=script&lang=js&"
export * from "./elite_position_details.vue?vue&type=script&lang=js&"
import style0 from "./elite_position_details.vue?vue&type=style&index=0&id=96d5e4b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d5e4b2",
  null
  
)

export default component.exports